import { rebuildTree } from '@/helpers/functions';
import * as types from '../mutation-types'
import axios from '@/axios'

export default {
	namespaced: true,

	state: {
		items: [],
		mixes: [],
		itemsTree: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/items').then((data) => {
				commit(types.STORE_ITEMS, data);
				return data
			})
		},
		fetchTree({ commit }) {
			return axios.get('/items/descendants').then((data) => {
				const tree = rebuildTree(data);
				commit(types.STORE_ITEMS_TREE, tree);
				return tree;
			})
		},

		fetchSuggestedNo({ commit }, { parentId }) {
			return axios.get('/items/generateItemNo', { params: { parentItemId: parentId } })
		},

		create({ commit }, { name, itemNo, innerItemNo, parentId, type, notes, isMix, itemCategory }) {
			return axios.post('/items', { name, itemNo, innerItemNo, parentId, type, notes, isMix, itemCategory });
		},

		update({ commit }, { id, name, itemNo, innerItemNo, parentId, type, notes, isMix, itemCategory }) {
			return axios.put(`/items/${id}`, { name, itemNo, innerItemNo, parentId, type, notes, isMix, itemCategory });
		},

		delete({ commit }, { id }) {
			return axios.delete(`/items/${id}`);
		},

		reset({ commit }) {
			commit(types.RESET);
		},

		// mixes
		fetchMixItems({ commit }, { itemId }) {
			return axios.get(`/items/mix/${itemId}`)
		},

		updateMixItems({ commits }, { itemId, items }) {
			return axios.put('/items', items, {
				params: { mixId: itemId },
				headers: { 'Content-Type': 'application/json' }
			});
		},
	},

	mutations: {
		[types.STORE_ITEMS](state, items) {
			state.items = items;
			state.mixes = items.filter(c => c.isMix);
		},
		[types.STORE_ITEMS_TREE](state, itemsTree) {
			state.itemsTree = itemsTree;
		},
		[types.RESET](state) {
			state.items = [];
			state.itemsTree = [];
		}
	},

	getters: {
		getItemById: state => id => state.items.find(c => c.id === id),
	}
}